import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetModel({ id }) {
  const fetchData = async () => {
    const response = await httpClient.get(`team/models/${id}`)
    return response.data.data
  }

  return useQuery({
    queryKey: ['models', 'detail', Number(id)],
    queryFn: fetchData,
    enabled: !!id,
  })
}
